module.exports = __webpack_public_path__ + "static/media/spray-can.aaa95ec6.svg";